
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { XeroLinkedService } from 'app/model/linkedservice/xero.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'XeroObject',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Xero_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Xero_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: XeroLinkedService.MODEL // Linked service redefined
        }
    }
})
export class XeroObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
